import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL, END_POINT_PO_SALES } from '../const';

export default function usePoPaymentTerms() {
  const token = sessionStorage.getItem('quotetoken')?.replace(/^"|"$/g, '');
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ data: [], loading: true, error: '', token });
  const refresh = useCallback(() => setAttempt(value => value + 1), []);

  useEffect(() => {
    window.addEventListener('focus', refresh);
    return () => window.removeEventListener('focus', refresh);
  }, [refresh]);

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    const current = () => active && sessionStorage.getItem('quotetoken')?.replace(/^"|"$/g, '') === token;
    setState(previous => ({ data: previous.token === token ? previous.data : [], loading: true, error: '', token }));
    axios.get(API_URL + END_POINT_PO_SALES + '/payment-terms', {
      headers: { Accept: 'application/json', Authorization: 'Bearer ' + token },
      signal: controller.signal,
    }).then(response => {
      if (!current()) return;
      if (!response.data?.status || !Array.isArray(response.data.data)) {
        throw new Error('Unable to load payment terms.');
      }
      setState({ data: response.data.data, loading: false, error: '', token });
    }).catch(error => {
      if (current()) setState({ data: [], loading: false, error: error.response?.data?.message || 'Unable to load payment terms.', token });
    });
    return () => { active = false; controller.abort(); };
  }, [token, attempt]);

  return { ...state, data: state.token === token ? state.data : [], refresh };
}
